export const DEFAULT_CURRENT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 15;
export const DEFAULT_WIDGET_TITLE = 'Associated Customers';
export const DEFAULT_MAP_NAMESPACE = 'TM_IAD.AlertAssocCustomers';
